<template>
<div id="main-body">
  <div class="d-cont"> 
    <div class="d-header">
      Capacity in Short-Term Memory
    </div>
    <progress class="d-progress" :value="progress" max="100"></progress>
    <div class="body">
      <div class="d-box" v-if="page==1">
        <div class="body">
          <div class="content">
            <h1>
              Capacity in Short-Term Memory
            </h1>
          </div>
          <div class="footer">
            <button class="btn" @click="page=2">
              START
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==2">
        <div class="body">
          <div class="content">
            <div class="d-ins">
              Suppose someone read out a list of 20 first names. How many of them do you think you
would be able to remember?<br><br>

The number of names you would be able to recall would reflect your memory span.<br><br>

The following exercise is going to test your memory span. The test uses letters of the
alphabet. On each trial you will be shown between 3 and 8 letters and your job is to try to remember and recall them by typing them into a text box on the screen.<br><br>

It is fine if you make mistakes, most people find this task very challenging. <br><br>

Click NEXT to continue. <br><br>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(1, 3)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- Trial 1 -->
      <div class="d-game" v-if="page==3">
        <div class="body">
          <span class="header">
            Trial 1 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==4">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[1][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[1][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[1][3]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(2, 5)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 1 -->
      <!-- Trial 2 -->
      <div class="d-game" v-if="page==5">
        <div class="body">
          <span class="header">
            Trial 2 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==6">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[2][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[2][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[2][3]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(3, 7)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of trial 2 -->
      <!-- Trial 3 -->
      <div class="d-game" v-if="page==7">
        <div class="body">
          <span class="header">
            Trial 3 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==8">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[3][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[3][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[3][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[3][4]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(4, 9)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 3 -->
      <!-- Trial 4 -->
      <div class="d-game" v-if="page==9">
        <div class="body">
          <span class="header">
            Trial 4 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==10">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT.<br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[4][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[4][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[4][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[4][4]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(5, 11)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 4 -->
      <!-- Trial 5 -->
      <div class="d-game" v-if="page==11">
        <div class="body">
          <span class="header">
            Trial 5 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==12">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[5][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[5][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[5][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[5][4]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[5][5]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(6, 13)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 5 -->
      <!-- Trial 6 -->
      <div class="d-game" v-if="page==13">
        <div class="body">
          <span class="header">
            Trial 6 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==14">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[6][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[6][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[6][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[6][4]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[6][5]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(7, 15)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End if Trial 6 -->
      <!-- Trial 7 -->
      <div class="d-game" v-if="page==15">
        <div class="body">
          <span class="header">
            Trial 7 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==16">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[7][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[7][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[7][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[7][4]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[7][5]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[7][6]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(8, 17)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 7 -->
      <!-- Trial 8 -->
      <div class="d-game" v-if="page==17">
        <div class="body">
          <span class="header">
            Trial 8 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==18">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[8][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[8][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[8][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[8][4]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[8][5]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[8][6]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(9, 19)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 8 -->
      <!-- Trial 9 -->
      <div class="d-game" v-if="page==19">
        <div class="body">
          <span class="header">
            Trial 9 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==20">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[9][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[9][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[9][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[9][4]">
              </div>
              <!-- <div class="w-100 d-block d-sm-none"></div> -->
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[9][5]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[9][6]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[9][7]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(10, 21)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 9 -->
      <!-- Trial 10 -->
      <div class="d-game" v-if="page==21">
        <div class="body">
          <span class="header">
            Trial 10 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==22">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[10][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[10][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[10][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[10][4]">
              </div>
              <!-- <div class="w-100 d-block d-sm-none"></div> -->
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[10][5]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[10][6]">
              </div>
              
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[10][7]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(11, 23)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 10 -->
      <!-- Trial 11 -->
      <div class="d-game" v-if="page==23">
        <div class="body">
          <span class="header">
            Trial 11 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==24">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][4]">
              </div>
              <!-- <div class="w-100 d-block d-sm-none"></div> -->
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][5]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][6]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][7]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[11][8]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="flash_stimuli(12, 25)">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 11 -->
      <!-- Trial 12 -->
      <div class="d-game" v-if="page==25">
        <div class="body">
          <span class="header">
            Trial 12 of 12
          </span>
          <div class="target">
            <div class="content">
              <span class="display-1">
                {{ displayed_stimuli }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==26">
        <div class="body">
          <div class="content">
            From memory, please enter the letters into the text boxes below, then click NEXT. <br><br>
            Press TAB on your keyboard to move to the next box, or if you are using a touch screen
device just press the next box.<br><br>
            <div class="row">
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][1]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][2]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][3]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][4]">
              </div>
              <!-- <div class="w-100 d-block d-sm-none"></div> -->
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][5]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][6]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][7]">
              </div>
              <div class="col-lg-1 px-1">
                <input type="text" class="form-control" v-model="response[12][8]">
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="results()">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of Trial 12 -->
      <!-- Start of Result Page -->
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==27">
        <div class="body">
          <div class="content" style="text-align: left !important;">
            <div class="row">
              <div class="col-lg-4">
                <h4>
                  Your results.
                </h4>
                <strong>
                  <p>
                    The graph shows the number of items you correctly recalled depending on the number of letters in the list. Using this data you can get an idea of your memory span.
                  </p>
                  
                </strong>
              </div>
              <div class="col-lg-8">
                <bar-chart :chartdata="overall"></bar-chart>
              </div>
              <div class="col-lg-12">
                <p>When a large number of people are tested on a similar task as this one, several patterns
begin to emerge in the data.</p><br>
                <p>
                 Miller (1958) reviewed a large number of such experiments and concluded that people can recall between five and nine items, with an average of seven. This is often stated as "7 plus or minus 2" and written 7 ±2, which Miller referred to as the "magic number".
                </p>
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn" @click="page=28">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==28">
        <div class="body">
          <div class="content" style="text-align: left !important;">
            <h4>
              Primacy and recency in short-term recall
            </h4>
            <p>
              There are other ways we can look at your data to inform us how short-term memory works. 
            </p> <br>
            <p>
              The following graphs show the number of letters you recalled correctly in respect to their position in each list. 
            </p> <br>
            <p>
              In the following graphs, an item is only correct if it has been recalled in the correct position.
            </p>
          </div>
          <div class="footer">
            <button class="btn" @click="page=29">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==29">
        <div class="body">
          <div class="content">
            <h4>Correctly Recalled Letters (4 letters)</h4>
            <line-chart :chart-data="four" title="Correctly Recalled Letters (4 letters)"></line-chart>
          </div>
          <div class="footer">
            <button class="btn" @click="page=30">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==30">
        <div class="body">
          <div class="content">
            <h4>
              Correctly Recalled Letters (5 letters)
            </h4>
            <line-chart :chart-data="five" title="Correctly Recalled Letters (5 letters)"></line-chart>
          </div>
          <div class="footer">
            <button class="btn" @click="page=31">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==31">
        <div class="body">
          <div class="content">
            <h4>
              Correctly Recalled Letters (6 letters)
            </h4>
            <line-chart :chart-data="six" title="Correctly Recalled Letters (6 letters)"></line-chart>
          </div>
          <div class="footer">
            <button class="btn" @click="page=32">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==32">
        <div class="body">
          <div class="content">
            <h4>
              Correctly Recalled Letters (7 letters)
            </h4>
            <line-chart :chart-data="seven" title="Correctly Recalled Letters (7 letters)"></line-chart>
          </div>
          <div class="footer">
            <button class="btn" @click="page=33">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==33">
        <div class="body">
          <div class="content">
            <h5 class="text-danger">
              Is a pattern forming?
            </h5>
            <h4>
              Correctly Recalled Letters (8 letters)
            </h4>
            <line-chart :chart-data="eight" title="Correctly Recalled Letters (8 letters)"></line-chart>
          </div>
          <div class="footer">
            <button class="btn" @click="page=34">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" v-if="page==34" :class="{ drd: isMobile() }">
        <div class="body">
          <div class="content">
            Next, you will see a graph that plots the pattern of data that typically emerges from testing a lot of people.
          </div>
          <div class="footer">
            <button class="btn" @click="page=35">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==35">
        <div class="body">
          <div class="content">
            <span class="text-danger">
              When a group of participants is tested, the results tend to look like this:
            </span>
            
            <h4>
              Correctly Recalled Letters (8 letters)
            </h4>
            <line-chart :chart-data="most" title="Correctly Recalled Letters (8 letters)"></line-chart>
          </div>
          <div class="footer">
            <div class="float-left">
              <button class="btn" style="background-color: #dddddd;" @click="page=33">
                PREV
              </button><br>
              <a @click="page=33" style="text-decoration: none !important;" class="d-none">Back to your graph</a>
            </div>
            <button class="btn" @click="page=36">
              NEXT
            </button>
          </div>
        </div>
      </div>
      
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==36">
        <div class="body">
          <div class="content" style="text-align: left !important;">
            <p>
              Note that the pattern is u-shaped. This pattern is called the serial position curve because:
            </p>
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(i) It refers to recalling a list of items serially (i.e. in order)
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(ii) The pattern reflects something happening at certain positions in the list, and
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(iii) It is the pattern obtained from nearly everyone – it is a universal finding. 
            <br><br>
            <p>
              Note that good recall appears for the first few and the last few items, and most of the
errors (or recall failures) occur for the items in the middle of the list.
            </p><br>
            <p>
              Your results may not be U-shaped at all. Can you think of reasons why?
            </p><br>
            <p>
              Try testing a friend, but this time you call out the letters in each trial. Ask your friend to
write down the letters and you can then enter them on the screen. When you look at their
results, check to see if they differ from yours in any way.
            </p>
          </div>
          <div class="footer">
            <button class="btn" @click="page=37">
              NEXT
            </button>
          </div>
        </div>
      </div>
      <!-- End of result Page -->
      <!-- Start of draggable -->
      
      <div class="d-box" :class="{ drd: isMobile() }" v-if="page==37">
        <div class="body">
          <div class="content" style="text-align: left !important;">
            <strong>Test your knowledge</strong><br><br>
            <!-- <draggable v-model="destination" group="people" @start="drag=true" @end="drag=false"> -->
              According to <draggable class="drap" v-model="destination[1]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[1]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              <draggable class="drap" v-model="destination[2]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[2]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' " >
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              most people’s short-term memory is limited to
              <draggable class="drap" v-model="destination[3]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[3]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              items. He called this the
              <draggable class="drap" v-model="destination[4]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[4]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              since it applies to most people and for most types of information. A 
              <draggable class="drap" v-model="destination[5]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[5]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              position curve is a plot of serial position against a number of items correctly recalled. The curve is
              <draggable class="drap" v-model="destination[6]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[6]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              . The high recall of the first few items is known as the
              <draggable class="drap" v-model="destination[7]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[7]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              effect, and the high recall of the last few items is known as the
              <draggable class="drap" v-model="destination[8]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[8]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              effect. When
              <draggable class="drap" v-model="destination[9]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[9]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              <draggable class="drap" v-model="destination[10]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[10]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              <draggable class="drap" v-model="destination[11]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[11]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              got people to rehearse a list out loud they found that they could only manage to rehearse the 
              <draggable class="drap" v-model="destination[12]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[12]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              few items.
              <draggable class="drap" v-model="destination[13]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[13]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              <draggable class="drap" v-model="destination[14]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[14]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              <draggable class="drap" v-model="destination[15]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[15]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              found that recency could be eliminated when
              <draggable class="drap" v-model="destination[16]" group="people" @start="drag=true" @end="drag=false" @change="toOrange">
                <div class="card mt-1 m-0 border-0" v-for="(element, key) in destination[16]" :key="key">
                  <div class="card-body" :style="'font-size: 15px !important; padding: 0px !important;background-color: ' + element.color + ';' ">
                    {{ element.name }}
                  </div>
                </div>
              </draggable>
              is prevented by a backward counting task.
            <!-- </draggable> -->
            <div class="card mt-3">
              <div class="card-body" style="padding: 1px!important; min-height: 100px !important;">
                <div>
                  <draggable class="row justify-content-center" v-model="source" group="people" @start="drag=true" @end="drag=false">
                    <div class="col-sm-3" v-for="(element, key) in source" :key="key">
                      <div class="card m-1" >
                        <div class="card-body" style="font-size: 15px !important; padding: 0px !important; width: 110px !important;">
                          {{ element.name }}
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
            
            
          </div>
          <div class="footer">
            <button class="btn mr-2" @click="checkDrag">
              &check; Check
            </button>
            <button class="btn" :disabled="correct!==16" @click.prevent="page=38">
              Next
            </button>
          </div>
          <span class="text-danger" v-if="warning">
            You have got {{ correct }} out of 16 correct, keep trying until you have all the 16 correct.
          </span>
        </div>
      </div>
      <!-- End of draggable -->
      <!-- Last page -->
      <div class="d-box" v-if="page==38">
        <div class="body">
          <div class="content">
            <h3>You have completed this exercise</h3><br>Thank you for participating
          </div>
          <div class="footer">
            <button class="btn" @click="reloadPage">
              TRY AGAIN
            </button>
          </div>
        </div>
      </div>
      <!-- End last page -->
    </div>
  </div>
</div>
  
</template>

<script>
import '@/assets/css/styles.css'
import draggable from 'vuedraggable'
import LineChart from '@/LineChart.vue'
import BarChart from '@/Bar.vue'

export default {
  name: 'app',
  components: {
    draggable,
    LineChart,
    BarChart
  },
  data() {
    return {
      page: 1,
      stimuli: {
        1: ['k', 'y', 'c'],
        2: ['b', 'r', 'h'],
        3: ['q', 'h', 'r', 'z'],
        4: ['j', 's', 'b', 'k'],
        5: ['b', 'h', 'm', 'g', 'm'],
        6: ['f', 'y', 'b', 'q', 'b'],
        7: ['g', 'h', 'y', 'j', 'h', 'j'],
        8: ['g', 'h', 'y', 'j', 'h', 'j'],
        9: ['g', 'h', 'y', 'j', 'h', 'j', 'j'],
        10: ['g', 'h', 'y', 'j', 'h', 'j', 'j'],
        11: ['g', 'h', 'y', 'j', 'h', 'j', 'j', 'j'],
        12: ['g', 'h', 'y', 'j', 'h', 'j', 'j', 'j']
      },
      response: {
        1: { 1: '', 2: '', 3: '' },
        2: { 1: '', 2: '', 3: '' },
        3: { 1: '', 2: '', 3: '', 4: '' },
        4: { 1: '', 2: '', 3: '', 4: '' },
        5: { 1: '', 2: '', 3: '', 4: '', 5: '' },
        6: { 1: '', 2: '', 3: '', 4: '', 5: '' },
        7: { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '' },
        8: { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '' },
        9: { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '' },
        10: { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '' },
        11: { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '' },
        12: { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '' },
      },
      displayed_stimuli: '',
      source: [
        {
          name: 'Miller',
          order: 1,
          fixed: false,
          color: 'white'
        },
        {
          name: '(1958)',
          order: 2,
          fixed: false,
          color: 'white'
        },
        {
          name: '7±2',
          order: 3,
          fixed: false,
          color: 'white'
        },
        {
          name: "'magic number'",
          order: 4,
          fixed: false,
          color: 'white'
        },
        {
          name: 'serial',
          order: 5,
          fixed: false,
          color: 'white'
        },
        {
          name: 'U-shaped',
          order: 6,
          fixed: false,
          color: 'white'
        },
        {
          name: 'primacy',
          order: 7,
          fixed: false,
          color: 'white'
        },
        {
          name: 'recency',
          order: 8,
          fixed: false,
          color: 'white'
        },
        {
          name: 'Rundus and',
          order: 9,
          fixed: false,
          color: 'white'
        },
        {
          name: 'Atkinson',
          order: 10,
          fixed: false,
          color: 'white'
        },
        {
          name: '(1970)',
          order: 11,
          fixed: false,
          color: 'white'
        },
        {
          name: 'first',
          order: 12,
          fixed: false,
          color: 'white'
        },
        {
          name: 'Glanzer and',
          order: 13,
          fixed: false,
          color: 'white'
        },
        {
          name: 'Cunitz',
          order: 14,
          fixed: false,
          color: 'white'
        },
        {
          name: '(1966)',
          order: 15,
          fixed: false,
          color: 'white'
        },
        {
          name: 'rehearsal',
          order: 16,
          fixed: false,
          color: 'white'
        }
      ],
      destination: {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
        8: [],
        9: [],
        10: [],
        11: [],
        12: [],
        13: [],
        14: [],
        15: [],
        16: []
      },
      warning: false,
      correct: 0,
      overall: {},
      later_results: {},
      four: {},
      five: {},
      six: {},
      seven: {},
      eight: {},
      most: {},
    }
  },
  mounted() {
    this.stimuli = {
      1: this.get_random_string(3),
      2: this.get_random_string(3),
      3: this.get_random_string(4),
      4: this.get_random_string(4),
      5: this.get_random_string(5),
      6: this.get_random_string(5),
      7: this.get_random_string(6),
      8: this.get_random_string(6),
      9: this.get_random_string(7),
      10: this.get_random_string(7),
      11: this.get_random_string(8),
      12: this.get_random_string(8)
    }
  },
  methods: {
    toOrange(prop) {
      if (prop.hasOwnProperty('added')) {
        //this.destination[prop.added.element.order][0].color = 
        prop.added.element.color = '#FF9800'
      }
    },
    checkDrag() {
      this.correct = 0
      _.forEach(this.destination, (value, key) => {
        let v = value[0] || undefined
        if (v != undefined) {
          if (key == v.order) {
            this.correct++
            this.destination[key][0].color = '#4CAF50'
          } else {
            this.destination[key][0].color = '#F44336'
          }
        }
      })
    },
    flash_stimuli(index, page) {
      this.page = page
      let i = 0

      const pause = (ms) => {
        return (new Promise(resolve => window.setTimeout(resolve, ms)))
      }

      // let pause = function(ms) {
      //   return(new Promise(function(resolve, reject) {
      //     window.setTimeout(function() { resolve(); }, ms)
      //   }))
      // }

      let limit = {
        1: 3,
        2: 3,
        3: 4,
        4: 4,
        5: 5,
        6: 5,
        7: 6,
        8: 6,
        9: 7,
        10: 7,
        11: 8,
        12: 8
      }

      let pages = {
        1: 4,
        2: 6,
        3: 8,
        4: 10,
        5: 12,
        6: 14,
        7: 16,
        8: 18,
        9: 20,
        10: 22,
        11: 24,
        12: 26
      }

      var test = (callback) => {
        this.displayed_stimuli = this.stimuli[index][i] || ''
        console.log(this.displayed_stimuli)
        pause(500).then( () => {
          this.displayed_stimuli = ''
          pause(500).then( () => {
            i++
            this.displayed_stimuli = this.stimuli[index][i] || ''
            
            if (i < limit[index]) {
              callback(callback)
            } else {
              this.page = pages[index]
              i = 0
            }
          })
        })
      }

      let tester = test(test)
    },
    clearTimer() {
      clearInterval(this.interval)
    },
    results() {
      let results = {
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
        8: []
      }
      let later_results = {
        4: {
          1: [], 2: [], 3: [], 4: []
        },
        5: {
          1: [], 2: [], 3: [], 4: [], 5: []
        },
        6: {
          1: [], 2: [], 3: [], 4: [], 5: [], 6: []
        },
        7: {
          1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: []
        },
        8: {
          1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: []
        }
      }
      let later_averages = {
        4: [],
        5: [],
        6: [],
        7: [],
        8: []
      }
      _.forEach(this.response, (value, key) => {
        _.forEach(value, (value2, key2) => {
          if (key == 1 || key == 2) {
            results[3].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0)
          } else if ( key == 3 || key == 4 ) {
            results[4].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0)
            later_results[4][key2].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0 )
          } else if ( key == 5 || key == 6 ) {
            results[5].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0)
            later_results[5][key2].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0 )
          } else if ( key == 7 || key == 8 ) {
            results[6].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0)
            later_results[6][key2].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0 )
          } else if ( key == 9 || key == 10 ) {
            results[7].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0)
            later_results[7][key2].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0 )
          } else if ( key  == 11 || key == 12 ) {
            results[8].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0)
            later_results[8][key2].push( value2 == this.stimuli[key][key2 - 1] ? 100 : 0 )
          }
        })
      })
      _.forEach(later_results, (value, key) => {
        _.forEach(value, (value2, key2) => {
          later_averages[key].push( _.mean(value2) )
        })
      })
      this.later_results = later_averages
      let averages = []
      _.forEach(results, (value) => {
        averages.push(Math.round(_.mean(value), 1))
      })
      this.overall = {
        labels: [3,4,5,6,7,8],
        datasets: [
          {
            backgroundColor: '#a9b4d5',
            data: averages
          }
        ]
      }
      this.four = {
        labels: [1,2,3,4],
        datasets: [
          {
            borderColor: '#06f',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            lineTension: 0,
            pointStyle: 'rect',
            data: later_averages[4]
          }
        ]
      }
      this.five = {
        labels: [1,2,3,4, 5],
        datasets: [
          {
             borderColor: '#06f',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            lineTension: 0,
            pointStyle: 'rect',
            data: later_averages[5]
          }
        ]
      }
      this.six = {
        labels: [1,2,3,4,5,6],
        datasets: [
          {
             borderColor: '#06f',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            lineTension: 0,
            pointStyle: 'rect',
            data: later_averages[6]
          }
        ]
      }
      this.seven = {
        labels: [1,2,3,4,5,6,7],
        datasets: [
          {
             borderColor: '#06f',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            lineTension: 0,
            pointStyle: 'rect',
            data: later_averages[7]
          }
        ]
      }
      this.eight = {
        labels: [1,2,3,4,5,6,7,8],
        datasets: [
          {
             borderColor: '#06f',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            lineTension: 0,
            pointStyle: 'rect',
            data: later_averages[8]
          }
        ]
      }
      this.most = {
        labels: [1,2,3,4,5,6,7,8],
        datasets: [
          {
             borderColor: '#06f',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            lineTension: 0,
            pointStyle: 'rect',
            data: [95, 76, 55, 37, 15, 10, 72, 98]
          }
        ]
      }
      this.page = 27
    },
    reloadPage(){
      window.location.reload()
    },
    isScroll() {
      let page = $(window)
      let box = $(".d-cont")
      let remH = page.outerHeight() - ( $(".d-header").outerHeight() )
      console.log(remH)
      console.log(box.outerHeight())
      if (box.outerHeight() > remH) {
        //box.css({"top":"50%","transform":"translate(-50%,-50%)"});
      }
      return box.outerHeight() > remH
    },
    isMobile: function() {
    	var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
    },
    get_random_string(string_length) {
      let random_string = []
      let random_ascii;
      for (let i = 0; i < string_length; i++) {
        random_ascii = Math.floor( (Math.random() * 25) + 97)
        random_string.push(String.fromCharCode(random_ascii))
      }
      return random_string
    }
  },
  computed: {
    progress: function() {
      return Math.round( (this.page - 1) * 2.631578947368421)
    },
    isScrolls: function() {
      let page = $(window)
      let box = $(".d-box")
      let remH = page.outerHeight() -  ($(".d-header").outerHeight())
      c
      return box.outerHeight() >= remH
      // let e = $('#main-body')
      // return e.css('overflow-y') == 'scroll' || e.css('overflow-y') == 'auto'
    }
  }
}
</script>

<style lang="scss">
  .drd {
    top: 100px;
    transform: translate(-50%);

  }
</style>
